import { useQuery } from 'react-query';
import { getData } from 'src/Utils';
export var useAmenities = function (buildingId) {
    var data = useQuery(['amenities', buildingId], function () {
        return buildingId
            ? getData('/amenities', { building_id: buildingId })
            : Promise.resolve({ amenities: [] });
    }, {
        refetchOnWindowFocus: false,
        enabled: !!buildingId,
    }).data;
    return (data === null || data === void 0 ? void 0 : data.amenities.map(function (_a) {
        var name = _a.name, id = _a.id, currency = _a.currency, price = _a.price, availability = _a.availability;
        return ({
            label: name,
            value: id,
            currency: currency,
            price: price,
            availability: availability,
        });
    })) || [];
};
